import { render, staticRenderFns } from "./my_group.vue?vue&type=template&id=77fc1b32&scoped=true"
import script from "./my_group.vue?vue&type=script&lang=js"
export * from "./my_group.vue?vue&type=script&lang=js"
import style0 from "./my_group.vue?vue&type=style&index=0&id=77fc1b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc1b32",
  null
  
)

export default component.exports